import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/images/gas-icon.svg?url";
const SvgGasIcon = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.0047 9.26921H10.2714C11.0078 9.26921 11.6047 9.86617 11.6047 10.6025V12.1359C11.6047 12.7987 12.142 13.3359 12.8047 13.3359C13.4675 13.3359 14.0047 12.7995 14.0047 12.1367V5.22059C14.0047 4.86697 13.7758 4.56227 13.5258 4.31223L10.6714 1.33594M4.00472 2.00254H8.00472C8.7411 2.00254 9.33805 2.59949 9.33805 3.33587V14.0015H2.67139V3.33587C2.67139 2.59949 3.26834 2.00254 4.00472 2.00254ZM14.0047 5.33587C14.0047 6.07225 13.4078 6.66921 12.6714 6.66921C11.935 6.66921 11.3381 6.07225 11.3381 5.33587C11.3381 4.59949 11.935 4.00254 12.6714 4.00254C13.4078 4.00254 14.0047 4.59949 14.0047 5.33587Z",
  stroke: "white"
}), /* @__PURE__ */ React.createElement("line", {
  x1: 4,
  y1: 9.99414,
  x2: 8,
  y2: 9.99414,
  stroke: "white"
}), /* @__PURE__ */ React.createElement("line", {
  x1: 4,
  y1: 11.9941,
  x2: 8,
  y2: 11.9941,
  stroke: "white"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4 8.16113H8",
  stroke: "white"
}));
export {SvgGasIcon as ReactComponent};
export default svgUrl;
